import axios from "axios";

const api = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor de request: adiciona Authorization, exceto para endpoints públicos
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    // URLs que não devem ter Authorization
    const publicEndpoints = [
      "/api/oauth/token",
      "/api/cidade/list",
      "/api/cnes/list",
      "/api/register",
    ];

    // Verifica se a URL do request bate com algum endpoint público
    const isPublic = publicEndpoints.some((endpoint) =>
      config.url?.startsWith(endpoint),
    );

    if (token && !isPublic) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// Interceptor de response: captura 401 e redireciona (com logs e fallback)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("token");
      localStorage.removeItem("acessoAtivo");
      localStorage.removeItem("perfilAtivo");
      window.location.replace("/login");
    }

    return Promise.reject(error);
  },
);
export default api;
